<template>
  <body class="joinOurMission-body">
    <div class="title">
      Join Our Mission<br />
      for Sustainable Innovation
    </div>
    <a
      href="mailto:info@wecobi.com?subject=General Inquiry&body=I would like to know more about your company."
      class="button"
      >Contact Us</a
    >
  </body>
</template>

<script>
export default {
  name: "JoinUs",
  components: {},
};
</script>

<style scoped>
.joinOurMission-body {
  width: 100%;
  height: 280px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
}

.joinOurMission-body::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to left, #f98140 28%, #eb4dbf 72%);
  opacity: 0.7;
  z-index: -1;
}
.title {
  font-size: 25px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
}
.button {
  width: 151px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 17px;
  font-weight: 600;
  border-radius: 30px;
  border: 2px solid #000000;
  color: #000000;
}
.button:hover {
  color: #ffffff;
  border: 2px solid #000000;
  background-color: #000000;
}
@media (max-width: 431px) {
  .title {
    font-size: 20px;
  }
}
</style>
